import { render, staticRenderFns } from "./PoleCoefficients.vue?vue&type=template&id=229a88d8&scoped=true&"
import script from "./PoleCoefficients.vue?vue&type=script&lang=js&"
export * from "./PoleCoefficients.vue?vue&type=script&lang=js&"
import style0 from "./PoleCoefficients.vue?vue&type=style&index=0&id=229a88d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a88d8",
  null
  
)

export default component.exports